import { render, staticRenderFns } from "./_List.vue?vue&type=template&id=8dc79f3a&scoped=true&"
import script from "./_List.vue?vue&type=script&lang=js&"
export * from "./_List.vue?vue&type=script&lang=js&"
import style0 from "./_List.vue?vue&type=style&index=0&id=8dc79f3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc79f3a",
  null
  
)

export default component.exports